/// <amd-module name="VSSUI/Components/Header/HeaderTitle" />
import * as React from "react";

import { IHeaderTitleProps, TitleSize } from "./Header.Props";

import { Tooltip } from "VSSUI/TooltipEx";
import { css, getSafeId } from "VSSUI/Util";

export function HeaderTitle(props: IHeaderTitleProps & Readonly<{ children: React.ReactNode }>) {
    const { ariaLevel = 1, id } = props;

    let titleSizeClass = undefined;
    switch (props.titleSize) {
        case TitleSize.Large:
            titleSizeClass = "title-m l";
            break;
        case TitleSize.Small:
            titleSizeClass = "title-xs s";
            break;
        case TitleSize.Medium:
        default:
            titleSizeClass = "body-xl m";
    }

    return (
        <Tooltip overflowOnly={true}>
            <div aria-level={ariaLevel} className={css(props.className, "bolt-header-title", titleSizeClass)} id={getSafeId(id)} role="heading">
                {props.children}
            </div>
        </Tooltip>
    );
}
